import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";
import {UserMin} from "../Models/UserMin";
import {TableBoName} from "../enums/table-bo-name.enum";

@Component({
	selector: 'app-clients',
	templateUrl: './clients.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./clients.component.less']
})
export class ClientsComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	textes: any;
	clients: UserMin[] = [];
	originalClients: UserMin[] = [];
	searchTerm: string = '';
	tabOptions: any = this.app.sharedToolsService.initTabOptions(TableBoName.USERS);
	userId: any = localStorage.getItem('user_id');

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Remove modalOpen from localStorage to avoid problems
		localStorage.removeItem("modalOpen");

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get all clients
		this.getAllUsersAltByUsrId(this.userId, this.app.type_client_id);

		// Get the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;

					// Get the modal texts
					this.app.dataInitService.getModalTextsOnce(modalsTxt => {
						this.modalsTxt = modalsTxt;
					});

					this.app.previousLabelTxt = this.app.sharedToolsService.getPaginationLabels('prev');
					this.app.nextLabelTxt = this.app.sharedToolsService.getPaginationLabels('next');
				})
			})
	}

	getAllUsersAltByUsrId(_userId: number, _typeId: number) {
		this.app.apiToolsService.getAllUsersAltByUsrId(_userId, _typeId).subscribe((clients: any) => {
			console.log("getAllUsersAltByUsrId ==> ", clients);
			this.clients = clients;
			this.originalClients = cloneDeep(clients);

			this.app.sharedToolsService.sortTable(this.tabOptions.sortKey, this.clients, this.tabOptions);
		});
	}

	search() {
		if (this.searchTerm) {
			this.clients = this.app.sharedToolsService.searchInTable(this.searchTerm, this.originalClients, [], this.textes.blocTable.cols);
		} else {
			this.clients = [...this.originalClients];
		}
		this.tabOptions = this.app.sharedToolsService.initTabOptions(TableBoName.USERS);
	}
}
